__turbopack_context__.v({
  "control": "pagination-module__hZ4J8q__control",
});
